var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.Auth.userProperties.system_settings
        .cost_centre_on_delegations !== _vm.settingTypes.NOT_AVAILABLE
        ? _c("v-select", {
            attrs: {
              items: _vm.costCentres,
              label: _vm.label,
              rules: [_vm.isRequiredValidator],
              "item-text": "name",
              "item-value": "name"
            },
            model: {
              value: _vm.contextModel,
              callback: function($$v) {
                _vm.contextModel = $$v
              },
              expression: "contextModel"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }